import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Competition from "../../common/Competition";
import LayoutHeader from "../../common/LayoutHeader";
import Footer from "../../common/LayoutFooter";
import PageLoader from "../../common/PageLoader";

const Competitions = () => {
  const [competitions, setCompetitions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCompetitions = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/competitions?populate=*`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        setCompetitions(data?.data || []);
      } catch (error) {
        console.error("Error fetching competitions:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCompetitions();
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const base = process.env.PUBLIC_URL || "";

  if (isLoading) {
    return (
      <>
        <LayoutHeader />
        <PageLoader />
      </>
    );
  }

  return (
    <div className="hypena-page-wrap">
      <LayoutHeader />
      <div className="hn-breadcrumb">
        <h1>Competitions</h1>
        <nav className="hn-breadcrumb-nav">
          <Link to={`${base}/`} onClick={scrollTop}>Home</Link>
          <i className="bi bi-chevron-right" />
          <span>Competitions</span>
        </nav>
      </div>
      <div className="hn-competitions-intro">
        <div className="hn-competitions-intro-inner">
          <div className="hn-competitions-icon">
            <i className="bi bi-trophy-fill" />
          </div>
          <div className="hn-competitions-copy">
            <h2>Compete. Win. Shine.</h2>
            <p>Explore local competitions and challenges. Enter for a chance to win and grow your skills.</p>
          </div>
        </div>
      </div>
      <section className="hn-section">
        <h2 className="hn-section-title">Current competitions</h2>
        <p className="hn-section-subtitle">Browse open competitions and find your next challenge</p>
        {competitions.length > 0 ? (
          <div className="hn-cards hn-cards-competitions">
            {competitions.map((competition) => (
              <Competition key={competition.id} competitionData={competition} />
            ))}
          </div>
        ) : (
          <div className="hn-empty-state">
            <i className="bi bi-trophy" />
            <p>No competitions open right now.</p>
            <span>Check back soon for new challenges.</span>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
};

export default Competitions;
